import React from 'react';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { store } from 'redux/store';
import { theme } from 'theme';

import { App } from './App';

const container = document.getElementById('root');
const root = createRoot(container);

Sentry?.init({
  dsn: 'https://808d77a35b1ac2b2679bd3b30f5f49c2@o4503965754916864.ingest.us.sentry.io/4508546564358144',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

root.render(
  <ThemeProvider theme={theme}>
    <Router>
      <Provider store={store}>
        <React.StrictMode>
          <Toaster />
          <CssBaseline />
          <App />
        </React.StrictMode>
      </Provider>
    </Router>
  </ThemeProvider>,
);
